const enterpriseIds = {    
	language_trainings: 'lkmlanguagetrainings',
    lead_ambrish: 'ambrish.rastogi',
    lead_anirudh: 'anirudh.a.goel',
    lead_abhilash: 'abhilash.d.bungale',
    lead_shruti: 'shruti.aggarwal'
}
const domain = 'accenture.com';

const languageTrainings = `${enterpriseIds.language_trainings}@${domain}`;
const leadAmbrish = `${enterpriseIds.lead_ambrish}@${domain}`;
const leadAnirudh = `${enterpriseIds.lead_anirudh}@${domain}`;
const leadAbhilash = `${enterpriseIds.lead_abhilash}@${domain}`;
const leadShruti = `${enterpriseIds.lead_shruti}@${domain}`;

export default {languageTrainings,leadAmbrish,leadAnirudh,leadAbhilash,leadShruti}